import CONFIG from 'config'
import { GET, POST } from './index'

// Same exported names as api/auth.js so consumers only change the import
// path. `agoraLogin` keeps its historic name (the Login page imports it as
// such); under the hood it now calls classfy-api (Odin) with the Google
// credential and composes `{ token, teacher }` by chaining
// teacher-google-login + auth/me. The access token is stored in localStorage
// between the two calls so fetchMe() picks it up from
// getAuthenticationToken() like any other authenticated call.
// AuthProvider.saveAuthentication will set it again on success, idempotently.

export const agoraLogin = async ({ credential }) => {
  const { accessToken } = await POST({
    url: '/auth/teacher-google-login',
    data: { credential },
    useAuth: false
  })
  localStorage.setItem(CONFIG.accessTokenKey, accessToken)
  try {
    const teacher = await fetchMe()
    return { token: accessToken, teacher }
  } catch (e) {
    localStorage.removeItem(CONFIG.accessTokenKey)
    throw e
  }
}

// v1 fetchMe accepted a { full: true } argument to switch between /me and
// /me/full. Odin's auth/me already returns the minimal legacy-shaped teacher
// used by AuthProvider (`id`, `name`, `profileUrl`, `active`, `email`, `tipo`).
// The argument is accepted and ignored to keep call-sites unchanged.
export const fetchMe = () => GET({ url: '/api/instructor/auth/me' })
